import { Button } from "@/components/ui/button";

interface AdminHeaderProps {
  onLogout: () => void;
}

export const AdminHeader = ({ onLogout }: AdminHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-4xl font-bold text-white">后台管理系统</h1>
      <Button onClick={onLogout} variant="destructive">
        退出登录
      </Button>
    </div>
  );
};